import './Login.scss';
import {FC, useState} from "react";
import axios from "axios";

interface Props {
	loginCallback: Function
}

const Login: FC<Props> = (props: Props) => {
	const [emailAddr, setEmailAddr] = useState<string>('');
	const [loggingIn, setLoggingIn] = useState<boolean>(false);
	const [invalidUser, setInvalidUser] = useState<boolean>(false);

	const loginClicked = () => {
		setLoggingIn(true);
		let loginFormData = new FormData();
		loginFormData.append('email', emailAddr);

		axios.post(`${process.env.REACT_APP_API_LOGIN_ENDPOINT}`, loginFormData,{withCredentials: true})
			.then(() => {
				props.loginCallback();
			})
			.catch((error) => {
				setInvalidUser(true);
				setLoggingIn(false);
			})
	}

	return (
		<div className="login-form">
			<h2>Login Required</h2>
			<p>In order to vote you will need to login with the email address you used to purchase your ticket.</p>
			<div className="form-element-wrapper">
				{invalidUser ? <p className="login-error">Email address does not exist</p> : ''}
				<input type="text" id="test" placeholder="Email address" value={emailAddr}
					   onChange={evt => setEmailAddr(evt.target.value)} disabled={loggingIn} />
				<button onClick={loginClicked} disabled={loggingIn}>Login</button>
			</div>
		</div>
	)
}

export default Login;
